<button class="k-button k-primary copy-link" (click)="copyLink()">
  Copy Link
</button>
